import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const locale = "labels";

const i18n = new VueI18n({
  locale,
  messages: {},
  silentTranslationWarn: true,
  fallbackLocale: "en",
});

export default i18n;
